import Modal, { ModalProps } from 'components/containers/Modal/Modal';
import Button from 'components/generics/buttons/Button';
import Typography from 'components/generics/texts/Typography';
import { disconnectBank } from 'hooks/integrations/plaid/utils';
import useFinancials from 'hooks/requests/financials/useFinancials';
import { toast } from 'react-toastify';
import useGlobalLoader from 'stores/GlobalLoader/globalLoader';
import classes from './index.module.scss';
import { useQuilttSession } from '@quiltt/react';
import useUserDetails from 'hooks/requests/user/hooks/useUserDetails';

const BankDisconnectDialog = ({ onClose, ...props }: ModalProps) => {
  const { setBankLoading, bankLoading } = useGlobalLoader();
  const { revokeSession } = useQuilttSession();
  const { request } = useFinancials();
  const { request: refetch } = useUserDetails();
  const { financialIdentities } = useFinancials();
  const financialConnectionId =
    financialIdentities?.relationships?.default_external_financial_connection
      ?.data?.id;
  return (
    <Modal
      className={classes.container}
      onClose={onClose}
      {...props}
    >
      <Typography className={classes.title}>Are you sure?</Typography>
      <Button
        onClick={async () => {
          setBankLoading(true);
          await disconnectBank(financialConnectionId, request, () =>
            toast('There was an error connecting your bank')
          );
          revokeSession();
          await refetch?.();
          setBankLoading(false);
          onClose();
        }}
        className={classes.approve}
        loading={bankLoading}
      >
        Yes, disconnect my bank
      </Button>
      <Button
        onClick={onClose}
        className={classes.cancel}
        variant={'secondary'}
      >
        Cancel
      </Button>
    </Modal>
  );
};

export default BankDisconnectDialog;
